module.exports = __webpack_public_path__ + "img/bloody.4897fa0.png";